export const SET_DELIVERY_SERVICES = 'SET_DELIVERY_SERVICES';
export const SET_SELLER_LIST = 'SET_SELLER_LIST';
export const SET_REFERENCE_RATE_LIST = 'SET_REFERENCE_RATE_LIST';

export interface DeliveryService {
  key: string,
  title: string,
  icon: string,
  rating: number,
  limited: boolean,
}

export type Seller = {
  sellerId: number,
  title: string,
  nds: boolean
};

export type Rate = {
  code: string,
  deliveryService: string,
  title: string,
  rateId: number,
};

export interface SetDeliveryServices {
  type: typeof SET_DELIVERY_SERVICES,
  deliveryServices: Array<DeliveryService>
}

export interface SetSellerList {
  type: typeof SET_SELLER_LIST,
  sellers: Array<Seller>,
}

export interface SetReferenceRateList {
  type: typeof SET_REFERENCE_RATE_LIST,
  list: Rate[],
}

export type ReferenceActions = SetDeliveryServices | SetSellerList | SetReferenceRateList;
